// @flow
import type {Axios} from "axios";
import axios from "axios";
import Configuration from "../Configuration";
import {getTrafficOrigin, shouldTrackOrigin} from "../helper/trafficOrigin";

// wire values expected by the statistics backend (X-Event-Type header)
const EVENT_TYPES = {
	SHOP_LOADED: "Shop loaded",
	PRODUCT_SHARED: "Product shared",
	ADDED_TO_WATCHLIST: "Product added to Bookmarks",
	PRODUCT_QUESTION: "Product ask a question clicked",
	ADDED_TO_CART: "Product added to cart",
};

export type StatisticApiOptions = {
	language: ?string,
}

export default class StatisticApi {
	api: Axios;

	constructor(configId: string, {
		language = navigator.language || "en-GB",
	}: StatisticApiOptions = {}) {
		const headers = {
			"X-ModuleType": "HPM",
			"Accept-Language": language + ", *;q0.5",
			"X-Origin": getTrafficOrigin() || "unknown",
			"X-ConfigId": configId,
		};
		this.api = axios.create({
			baseURL: Configuration.value("apiBaseUrl"),
			headers
		});
	}

	trackModuleLoad = (): void => {
		if (shouldTrackOrigin()) {
			this.trackEvent(EVENT_TYPES.SHOP_LOADED);
		}
	};

	trackProductShared = (productNo: string): void => {
		this.trackEvent(EVENT_TYPES.PRODUCT_SHARED, productNo);
	};

	trackAddedToWatchlist = (productNo: string): void => {
		this.trackEvent(EVENT_TYPES.ADDED_TO_WATCHLIST, productNo);
	};

	trackProductQuestion = (productNo: string): void => {
		this.trackEvent(EVENT_TYPES.PRODUCT_QUESTION, productNo);
	};

	trackProductAddedToCart = (productNo: string): void => {
		this.trackEvent(EVENT_TYPES.ADDED_TO_CART, productNo);
	};

	trackEvent = (eventType: string = "", productNo: string = ""): void => {
		this.api.post("/v2/loading/completed",
			{},
			{
				headers: {
					"X-Event-Type": eventType,
					"X-Product-No": productNo.trim()
				}
			}).catch(() => {
		});
	};
}
